/**
 * placeholder 默认是 pointer-events-none 的整段文案，点击会穿透去聚焦编辑器。
 * 提供 onAtButtonClick 时，把文案中第一个 "@" 拆成独立按钮，允许其恢复 pointer-events
 * 并直接打开主体选择弹窗，其余文字仍保持穿透行为不变。
 */
export const renderPlaceholderWithAtButton = (placeholder: string, onAtButtonClick?: () => void) => {
  if (!onAtButtonClick) {
    return placeholder;
  }

  const atIndex = placeholder.indexOf('@');
  if (atIndex === -1) {
    return placeholder;
  }

  return (
    <>
      {placeholder.slice(0, atIndex)}
      <button
        type="button"
        className="pointer-events-auto mx-0.5 inline-flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-8 bg-white/[0.12] text-system-white64 transition-colors hover:bg-white/[0.18] hover:text-system-white"
        onClick={onAtButtonClick}
      >
        @
      </button>
      {placeholder.slice(atIndex + 1)}
    </>
  );
};
